import industryService from "../../services/industry.service";


export const state ={
    industries:[],
    industries_by_actions:[],

    industry_company_distribution:[],
    industry_company_distribution_labels:[],

    top_industry_actions:[],
    top_industry_actions_labels:[],

    top_company_industry_actions:[],
    top_company_industry_actions_labels:[],

    monthly_industry_actions:[],
    monthly_industry_actions_labels:[],

}
export const actions = {
    fetch_industries({commit}, page){
        return  industryService.get_industries(page).then(
            data => {                 
                commit ('SET_INDUSTRIES', data.data);
                return Promise.resolve(data.data);
            }, error => {
                commit('AssetsFailed');
                return Promise.reject(error);
            }
        );
    },

    async fetchIndustryCompanyDistribution({ commit }) {
        try {
    
            await industryService.industry_company_distribution().then(
                response => {
                    
                    commit('SET_INDUSTRY_COMPANY_DISTRIBUTION', response);
                }
            )
            
        } catch (error) {
            console.error('Error fetching actions by year:', error);
        }
    },
    async fetchActionsByIndustries({ commit }, yearOrRange) {
        try {
            let yearParam;
            if (Array.isArray(yearOrRange)) {
                yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
            } else {
                yearParam = yearOrRange;
            }
    
            await industryService.actions_by_industry(yearParam).then(
                response => {
                    
                    commit('setIndustriesActionsData', response.data);
                }
            )
            
        } catch (error) {
            console.error('Error fetching actions by year:', error);
        }
    },
    async fetchTopIndustriesByActions({ commit }, yearOrRange) {
        try {
            let yearParam;
            if (Array.isArray(yearOrRange)) {
                yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
            } else {
                yearParam = yearOrRange;
            }
    
            await industryService.top_industry_actions(yearParam).then(
                response => {
                    
                    commit('SET_TOP_INDUSTRY_ACTIONS', response);
                }
            )
            
        } catch (error) {
            console.error('Error fetching actions by year:', error);
        }
    },
    async fetchTopCompanyIndustriesByActions({ commit }, yearOrRange) {
        try {
            let yearParam;
            if (Array.isArray(yearOrRange)) {
                yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
            } else {
                yearParam = yearOrRange;
            }
    
            await industryService.top_company_industry_actions(yearParam).then(
                response => {
                    
                    commit('SET_TOP_COMPANY_INDUSTRY_ACTIONS', response);
                }
            )
            
        } catch (error) {
            console.error('Error fetching actions by year:', error);
        }
    },
    
    async fetchMonthlyIndustriesByActions({ commit }, yearOrRange) {
        try {
            let yearParam;
            if (Array.isArray(yearOrRange)) {
                yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
            } else {
                yearParam = yearOrRange;
            }
    
            await industryService.monthly_industry_actions(yearParam).then(
                response => {
                    
                    
                    commit('SET_MONTHLY_INDUSTRY_ACTIONS', response);
                }
            )
            
        } catch (error) {
            console.error('Error fetching actions by year:', error);
        }
    },

}
export const mutations = {
    
    SET_INDUSTRIES(state,industries){
        state.industries = industries
    },
    setIndustriesActionsData(state,data){
        
        state.industries_by_actions = data
    },

    SET_INDUSTRY_COMPANY_DISTRIBUTION(state, data){     
        state.industry_company_distribution = data.data
        state.industry_company_distribution_labels = data.labels
    },

    SET_TOP_INDUSTRY_ACTIONS(state, data){     
        state.top_industry_actions = data.data
        state.top_industry_actions_labels = data.labels
    },
    SET_TOP_COMPANY_INDUSTRY_ACTIONS(state, data){     
        state.top_company_industry_actions = data.series
        state.top_company_industry_actions_labels = data.labels
    },

    SET_MONTHLY_INDUSTRY_ACTIONS(state, data){     
        state.monthly_industry_actions = data.series
        state.monthly_industry_actions_labels = data.labels
    },
    
}
export const getters = {
    get_industries(state){
        return state.industries 
    },

    get_industries_by_actions(state){
        return state.industries_by_actions
    },

    get_industry_company_distribution(state){
        return state.industry_company_distribution
    },
    get_industry_company_distribution_labels(state){
        return state.industry_company_distribution_labels
    },

    get_top_industry_actions(state){
        return state.top_industry_actions
    },
    get_top_industry_actions_labels(state){
        return state.top_industry_actions_labels
    },
    get_top_company_industry_actions(state){
        return state.top_company_industry_actions
    },
    get_top_company_industry_actions_labels(state){
        return state.top_company_industry_actions_labels
    },

    get_monthly_industry_actions(state){
        return state.monthly_industry_actions
    },
    get_monthly_industry_actions_labels(state){
        return state.monthly_industry_actions_labels
    }

}


